<!-- src/components/Footer.vue -->
<template>
	<footer class="bg-primary text-light py-3" data-aos="fade-up">
		<div class="container">
			<div class="row">
				<div class="col-lg-3 col-md-6">
					<h5>Links Úteis</h5>
					<ul class="list-unstyled">
						<li><i class="bx bx-chevron-right"></i> <a href="#">Home</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Carros</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Motos</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Caminhões</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Barcos</a></li>
					</ul>
				</div>

				<div class="col-lg-3 col-md-6">
					<h5>Serviços</h5>
					<ul class="list-unstyled">
						<li><i class="bx bx-chevron-right"></i> <a href="#">Financiar</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Venda Rápida</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Tabela Fipe</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Anunciar</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Parceiros</a></li>
					</ul>
				</div>

				<div class="col-lg-3 col-md-6">
					<h5>Institucional</h5>
					<ul class="list-unstyled">
						<li><i class="bx bx-chevron-right"></i> <a href="#">Quem Somos</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Notícias</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Canal de denúncias</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Termo de Uso</a></li>
						<li><i class="bx bx-chevron-right"></i> <a href="#">Trabalhe Conosco</a></li>
					</ul>
				</div>

				<div class="col-lg-3 col-md-6">
					<h5>D'AutoS</h5>
					<p>
						Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus.
					</p>
					<PwaInstallButton />
					<ul class="d-flex justify-content-center justify-content-evenly">
						<!-- favicons -->
						<a href="https://instagram.com/cbftravinha" class="instagram" target="_blank"><li class="list-inline-item"><i class="fab fa-2x fa-instagram"></i></li></a>
						<a href="https://facebook.com/cbftravinha" class="facebook" target="_blank"><li class="list-inline-item"><i class="fab fa-2x fa-facebook"></i></li></a>
						<a href="https://youtube.com/channel/UC6nGa5mMDuvYKy1qMrglxAQ" class="youtube" target="_blank"><li class="list-inline-item"><i class="fab fa-2x fa-youtube"></i></li></a>
					</ul>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import PwaInstallButton from "@/components/PwaInstallButton.vue";

export default {
	components: {
		PwaInstallButton,
	},
};
</script>
